/**
 * Gets project permissions of member
 * @updated 04/11/2024
 * @public
 * @param ctx StateContext<MeStateModel>
 * @param userId string
 * @param projectId string
 * @see libs/app/client/shared/states/src/lib/me/states/me.state.ts
 */ export class GetProjectPermissions {
  public static readonly type = '[Me] GetProjectPermissions';
  constructor(
    public readonly userId: string,
    public readonly projectId: string,
  ) {}
}
